import { optionSubcategory_Search } from './searchSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { PrivacyReferenceOption } from 'owa-privacy-option';
import { SearchTopResultsOption } from 'owa-search-topresults-option';
import { SearchResultsOption } from 'owa-search-results-option';

let searchSubcategory: OptionSubCategory = {
    key: 'search',
    titleStringKey: optionSubcategory_Search,
    options: [SearchTopResultsOption, SearchResultsOption, PrivacyReferenceOption],
};

export default searchSubcategory;
